import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import CheckIcon from '@material-ui/icons/Check'
import React, { FC } from 'react'

import { useStyles } from './HeroSection.styles'

interface CheckBulletPointProps {
  message: string
}

export const CheckBulletPoint: FC<CheckBulletPointProps> = ({ message }) => {
  const classes = useStyles()

  return (
    <Box position='relative' pl={ 3.5 } my={ 1.5 }>
      <CheckIcon className={ classes.checkIcon } />
      <Typography>{ message }</Typography>
    </Box>
  )
}
